'use client';

import { cn } from '@/utils/tailwind-merge';

interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
    label?: string;
    checked?: boolean;
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    truncate?: boolean;
    /** Let long labels wrap onto more lines instead of overflowing. */
    wrap?: boolean;
}

const Checkbox = ({
    label,
    checked,
    className,
    onChange,
    truncate,
    wrap,
    ...rest
}: CheckboxProps) => {
    return (
        <label
            className={cn(
                'inline-flex gap-2.5 items-center cursor-pointer min-w-0 w-full',
                className,
            )}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                className="hidden"
                {...rest}
            />
            <span
                className={cn(
                    'w-5 h-5 min-w-5 min-h-5 border flex justify-center items-center mr-2',
                    checked ? 'border-primary' : 'border-white',
                )}
            >
                {checked && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        className="w-4 h-4 text-primary"
                    >
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                )}
            </span>
            <span
                className={cn(
                    'uppercase text-2xl leading-8 max-w-full',
                    truncate ? 'truncate' : wrap ? 'min-w-0 break-words' : 'text-nowrap',
                    checked ? 'text-primary' : 'text-white',
                )}
            >
                {label}
            </span>
        </label>
    );
};

export default Checkbox;
